export const APP_LOGIN_STORAGE_KEY = 'app-login'

export const YOUTUBE_LOGIN_STORAGE_KEY = 'youtube-login'

export const USER_ID_STORAGE_KEY = 'user-id'

export const GURU_TOKEN_GOOGLE_OAUTH_CONFIG = {
  clientId: process.env.NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID,
  responseType: 'id_token permission',
  cookiePolicy: 'single_host_origin',
  prompt: 'consent',
  scope:
    'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
}

export const ACCESS_TOKEN_GOOGLE_OAUTH_CONFIG = Object.assign(
  {},
  GURU_TOKEN_GOOGLE_OAUTH_CONFIG,
  {
    responseType: 'code',
  }
)
